import { selectIsBasicPlanWithoutQTE } from '@/reducers/subscription.slice'
import { useReselector } from '@/utils/sharedHooks'
import {
  BookkeepingOnboardingStep,
  OnboardingStepPhase,
  TaxesOnboardingStep,
} from '@/features/onboarding/user-onboarding-steps/onboarding.reducer'

import {
  LearnWithHeardItem,
  LearnWithHeardItemProps,
} from './LearnWithHeardItem'
import { Text } from '@/ui'
import { ImageBackgroundColors, TypographyStyles } from '@/styles'

export const LearnWithHeard = () => {
  const LearnWithHeardItems: LearnWithHeardItemProps[] = [
    {
      key: 'bookkeeping',
      imageBackgroundColor: ImageBackgroundColors.ORANGE,
      imageSrc:
        'https://heard-images.s3.amazonaws.com/assets/books_lightShadow.png',
      imageAlt: 'books',
      title: 'Bookkeeping',
      description:
        'Learn why bookkeeping matters, how we help you save time, and what you need to do on a monthly basis.',
      navigateTo: '/onboarding-v2/learning/bookkeeping',
      timeItTakes: '5 minutes',
      onboardingStepPhase: OnboardingStepPhase.ahaMomentBookkeeping,
      completionStep: BookkeepingOnboardingStep.transactionsClarifiedSuccess,
    },
  ]
  const isBasicPlanWithoutQTE = useReselector(selectIsBasicPlanWithoutQTE)
  if (!isBasicPlanWithoutQTE) {
    LearnWithHeardItems.push({
      key: 'readyForTaxes',
      imageBackgroundColor: ImageBackgroundColors.GREEN,
      imageSrc:
        'https://heard-images.s3.amazonaws.com/assets/calculator_list.svg',
      imageAlt: 'calculator',
      title: 'Get ready for taxes',
      description:
        'Understand the tax process, how we help you avoid penalties, and how we maximize your tax savings.',
      navigateTo: '/onboarding-v2/learning/taxes',
      timeItTakes: '5 minutes',
      onboardingStepPhase: OnboardingStepPhase.ahaReadyForTaxes,
      completionStep: TaxesOnboardingStep.taxesSuccess,
    })
  }
  return (
    <div className="flex flex-col space-y-6">
      <Text variant={TypographyStyles.H1}>Learn with Heard</Text>
      <Text>Set your therapy practice up for success.</Text>

      <div
        className={`flex flex-row gap-4 ${
          LearnWithHeardItems.length > 2 ? 'justify-between' : 'justify-start'
        }`}
      >
        {LearnWithHeardItems.map((item) => (
          <LearnWithHeardItem {...item} key={item.key} />
        ))}
      </div>
    </div>
  )
}
